import { Button, Modal } from 'elmo-elements';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import './navPrompt.scss';

interface NavigatePromptProps {
  canShowPrompt: boolean;
}

export const NavigatePrompt = (props: NavigatePromptProps) => {
  const { canShowPrompt: when } = props;
  const history = useHistory();
  const unblockRef = useRef<any>(null);

  const [showPrompt, setShowPrompt] = useState(false);
  const [isAnchor, setIsAnchor] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const [promptContent, setPromptContent] = useState(
    'This page has unsaved changes. Are you sure you want to leave this page?',
  );

  const messageDisplayHandler = (isModulePath: boolean, isSlidePath: boolean) =>
    isModulePath && isSlidePath
      ? 'This page has unsaved changes. Are you sure you want to leave this page?'
      : 'You are about to leave this module with unsaved changes. Are you sure you want to leave this module?';

  // Add Browser message confirmation dialog for TMS menus (covers location.href navigations)
  useEffect(() => {
    const anchorTags = $('div.ela-menu a');

    const onClick = (
      e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>,
    ) => {
      const target = e.currentTarget as HTMLAnchorElement;
      if (when && target.href) {
        e.preventDefault();
        const isModulePath = target.href.includes('/module');
        const isSlidePath = target.href.includes('/slide');
        setPromptContent(messageDisplayHandler(isModulePath, isSlidePath));
        setCurrentPath(target.href);
        setIsAnchor(true);
        setShowPrompt(true);
      } else {
        setCurrentPath('');
      }
    };

    anchorTags.on('click', onClick);

    return () => {
      anchorTags.off('click', onClick);
    };
  }, [when]);

  useEffect(() => {
    if (when) {
      unblockRef.current = history.block((prompt) => {
        const isModulePath = prompt.pathname.includes('/module');
        const isSlidePath = prompt.pathname.includes('/slide');

        setPromptContent(messageDisplayHandler(isModulePath, isSlidePath));
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
        return false;
      });
    } else {
      unblockRef.current = history.block(() => {});
    }

    return () => {
      if (unblockRef.current) unblockRef.current();
    };
  }, [when]);

  const handleOK = () => {
    if (unblockRef) {
      unblockRef.current();
    }

    setShowPrompt(false);

    if (isAnchor) {
      window.location.href = currentPath;
    } else {
      history.push(currentPath);
    }
  };

  const handleCancel = () => {
    setIsAnchor(false);
    setShowPrompt(false);
  };

  return showPrompt ? (
    <Modal
      className="nav-prompt-modal"
      type="small"
      isOpened={showPrompt}
      closeModal={handleCancel}
      title="Unsaved changes"
      primaryButton={
        <div className="nav-prompt">
          <Button type="default" isUppercase={false} onClick={handleCancel}>
            Stay on page
          </Button>
          <Button type="primary" isUppercase={false} onClick={handleOK}>
            Continue
          </Button>
        </div>
      }
      closeLabel="Close"
    >
      {promptContent}
    </Modal>
  ) : null;
};
